export class DefaultTimeSheetSetting {
    defaultTimesheetTask: string
    defaultTimesheetProject: string
    defaultTimesheetWorkTimeTypeId: number
}
